var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7578 25.6836V32.4473C12.7578 32.9198 13.0611 33.3384 13.5103 33.4871C13.6226 33.5236 13.7378 33.5411 13.8516 33.5411C14.1928 33.5411 14.5224 33.3807 14.7324 33.0948L18.6888 27.7107L12.7578 25.6836Z",
    fill: "#D9622A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5406 0.202837C34.2052 -0.0348707 33.7647 -0.0669539 33.4002 0.124087L0.587771 17.2594C0.199856 17.4622 -0.0291017 17.8763 0.00298152 18.3124C0.0365231 18.7499 0.326731 19.1232 0.739437 19.2646L9.86128 22.3826L29.2877 5.77219L14.2552 23.8832L29.5429 29.1084C29.6566 29.1463 29.7762 29.1667 29.8958 29.1667C30.0941 29.1667 30.291 29.1127 30.4645 29.0077C30.7416 28.8386 30.9298 28.5542 30.9779 28.2348L34.9883 1.25575C35.0481 0.847418 34.876 0.442003 34.5406 0.202837Z",
    fill: "#D9622A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/send-message-icon.eeecccebd7c28a05a479497e9b29cbb5.svg";
export { ForwardRef as ReactComponent };